import { createFileRoute } from '@tanstack/react-router'

import { MatchSheetPage } from '@/features/matches/MatchSheetPage'

export const Route = createFileRoute('/_app/matches/$matchId/sheet')({
  component: MatchSheetRouteComponent,
})

function MatchSheetRouteComponent() {
  const { matchId } = Route.useParams()
  return <MatchSheetPage matchId={matchId} />
}
